import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-editaccessmanagement',
  templateUrl: './editaccessmanagement.component.html',
  styleUrls: ['./editaccessmanagement.component.css']
})
export class EditaccessmanagementComponent implements OnInit {
  returnUrl= "/dashboard/editaccessmanagementone";
  constructor(private router: Router) { }

  ngOnInit(): void {
    $('.selectpicker').selectpicker('refresh');
  }
  editaccessOne(){
    this.router.navigate([this.returnUrl]);
  }
}
